(() => {
  const widgetSelector = '.jdgm-widget';
  const observedWidgets = new WeakSet();

  const updateReviewState = (widget) => {
    widget.classList.toggle('inkybox-review-has-reviews', Boolean(widget.querySelector('.jdgm-rev')));
  };

  const enhanceWidget = (widget) => {
    let frame = 0;
    const scheduleBuild = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        updateReviewState(widget);
      });
    };

    scheduleBuild();
    if (observedWidgets.has(widget)) return;

    observedWidgets.add(widget);
    new MutationObserver(scheduleBuild).observe(widget, { childList: true, subtree: true });
  };

  const findWidgets = () => document.querySelectorAll(widgetSelector).forEach(enhanceWidget);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', findWidgets, { once: true });
  } else {
    findWidgets();
  }

  const mountObserver = new MutationObserver(() => {
    findWidgets();
    if (document.querySelector(widgetSelector)) mountObserver.disconnect();
  });

  mountObserver.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => mountObserver.disconnect(), 15000);
})();
